var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"baseview"},[_c('router-view',{style:(_vm.viewStyle)}),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"loadscreen"},[_c('div',{staticClass:"loader"}),_vm._v(" "),_c('div',{staticClass:"sub-load-text"},[_vm._v(_vm._s(_vm.loadText))])]):_vm._e(),_vm._v(" "),_c('navigation',{staticClass:"navigation"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c5a3490","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BaseView.vue
// module id = null
// module chunks = 